import apiService from './api.service';
import { config } from '../config';

/**
 * Get list of countries
 */
async function getCountries(market = 'lu-en') {
  const countries = await apiService.client(
    `/v2/cms-www-api/data/geo/cep/?market=${market}`,
    {
      method: 'GET',
    },
    config.D360_BASE_URL
  );
  return countries;
}

export default { getCountries };
